import React from 'react';

interface LogoutIconProps {
  className?: string;
  style?: React.CSSProperties;
  strokeWidth?: number;
}

export const LogoutIcon: React.FC<LogoutIconProps> = ({ className, style, strokeWidth = 2 }) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M11.9958 3H3V21H12M16.5 16.5L21 12L16.5 7.5M8 11.9958H21"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LogoutIcon;